import {dropDisabledNoRendererReads} from "#material/nodes/color/invert/validation"
import {optionalMaterialInput} from "#material/nodes/base/connection/validation/parameters"
import type {MaterialNodeDefinition} from "#material/nodes/base/material/types/definition"
import {ExchangeNodeName} from "#material/exchange/node-name"
import {materialColorOutput} from "#material/nodes/base/material/validation/io"
import {materialUiSchema} from "#material/nodes/base/material/validation/ui"
import type {MaterialNodeSockets} from "#material/types/material-node-sockets"
import {color, versionChain} from "@cm/graph-v3"
import {z} from "zod/v4-mini"

export interface InvertSockets extends MaterialNodeSockets {
    inputs: {
        color: "color" // found in inputs: color,float; found in settings: color; inferred from data: float3
        fac: "float" // found in inputs: color; found in settings: float; inferred from data: float
    }
    settings: {
        color: "color" // found in inputs: color,float; found in settings: color; inferred from data: float3
        fac: "float" // found in inputs: color; found in settings: float; inferred from data: float
    }
    outputs: {
        color: "color"
    }
}

export const invertDefinition = {
    exchangeFormat: {
        nodeName: ExchangeNodeName.ShaderNodeInvert,
    },
    nodeClass: "Invert",
    versionChain: versionChain([dropDisabledNoRendererReads]),
    ui: {
        label: "Invert",
        color: "#6e5eb2",
        disableable: true,
        items: [
            {name: "color", valueType: "color", label: "Color", output: true},
            {name: "color", valueType: "color", label: "Color", input: true, setting: true, defaultValue: {r: 0.0, g: 0.0, b: 0.0}},
            {name: "fac", valueType: "float", label: "Fac", defaultValue: 1, range: {min: 0, max: 1}, input: true, setting: true},
        ],
        support: {
            cycles: true,
            three: true,
        },
    },
    validation: {
        returns: z.strictObject({color: materialColorOutput}),
        parameters: z.strictObject({
            inputs: z.strictObject({
                color: optionalMaterialInput,
                fac: optionalMaterialInput,
            }),
            settings: z.strictObject({
                color: z.optional(color),
                fac: z.optional(z.number()),
            }),
            ui: materialUiSchema,
        }),
    },
} satisfies MaterialNodeDefinition<InvertSockets>
